import { createTheme } from "@mui/material/styles";
// import palette from "./palette";
import { green, grey, red } from "@mui/material/colors";
// import BebasNeuePro-Bold from "/assets/BebasNeuePro-Bold.ttf"
const rawTheme = createTheme({
  palette: {
    primary: {
      light: "#F18805",
      main: "#F18805",
      dark: "#F18805",
      contrastText: "#fff",
    },
    secondary: {
      light: "#1A1A1A",
      main: "#1A1A1A",
      dark: "#1A1A1A",
      contrastText: "#fff",
    },
    warning: {
      main: "#ffc071",
      dark: "#ffb25e",
    },
    error: {
      light: red[50],
      main: red[500],
      dark: red[700],
    },
    success: {
      light: green[50],
      main: green[500],
      dark: green[700],
    },
    text: {
      primary: "#fff",
      secondary: "#fff",
      h1: {
        light: "#fb8901",
        main: "#fb8901",
        dark: "#fb8901",
      },
    },
  },
  typography: {
    // font-family: 'Bebas Neue', cursive;

    fontSize: 14,
    fontWeightLight: 300, // Work Sans
    fontWeightRegular: 400, // Work Sans
    fontWeightMedium: 500, // Roboto Condensed
  },
});

const fontHeader = {
  // color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  // fontFamily: "'Roboto Condensed', sans-serif",
  fontFamily: ["Bebas Neue", "cursive"].join(","),

  textTransform: "uppercase",
};
const fontBody = {
  // color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontSize: { xs: 14, sm: 20, md: 20, lg: 32, xl: 34 },

  // fontFamily: "'Roboto Condensed', sans-serif",
  fontFamily: ["Poppins", "sans-serif"].join(","),
};

export const theme = {
  ...rawTheme,
  palette: {
    ...rawTheme.palette,
    background: {
      ...rawTheme.palette.background,
      default: rawTheme.palette.common.white,
      placeholder: grey[200],
    },
  },
  typography: {
    ...rawTheme.typography,
    fontHeader,
    h1: {
      ...rawTheme.typography.h1,
      ...fontHeader,
      ...rawTheme.palette.text.h1.main,
      letterSpacing: 0,
      fontSize: 60,
    },
    h2: {
      ...rawTheme.typography.h2,
      color: rawTheme.palette.text.h1.main,

      ...fontHeader,
      fontSize: 44,
      // fontWeight: 700,
    },
    h3: {
      ...rawTheme.typography.h3,
      ...fontHeader,
      fontSize: 42,
    },
    h4: {
      ...rawTheme.typography.h4,
      ...fontHeader,
      fontSize: 36,
    },
    h5: {
      ...rawTheme.typography.h5,
      fontSize: 20,
      fontWeight: rawTheme.typography.fontWeightLight,
    },
    h6: {
      ...rawTheme.typography.h6,
      ...fontHeader,
      fontSize: 18,
    },
    subtitle1: {
      ...rawTheme.typography.subtitle1,
      fontSize: 18,
    },
    body1: {
      ...rawTheme.typography.body2,
      ...fontBody,
      color: "#f0f0f0",
      margin: "auto",
      marginTop: 1,
      // maxWidth: { xs: 600, md: 1000 },

      fontWeight: rawTheme.typography.fontWeightRegular,
    },
    body2: {
      ...rawTheme.typography.body1,
      fontSize: 14,
    },
  },
};
